<template>
  <LegalSiteArticle :page="disclaimerPage" nav-page="disclaimer" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { disclaimerPage } from '@/data/legalPages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { disclaimerPage }
  },
}
</script>
